export const LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS =
  "bg-white text-gray-700 border border-gray-200 px-4 h-11 rounded-[2rem] text-sm font-bold shadow-sm hover:bg-gray-50 transition flex items-center gap-2 flex-shrink-0";

export const LIST_TOOLBAR_DOWNLOAD_MENU_CLASS =
  "absolute right-0 top-14 bg-white border border-gray-100 shadow-xl rounded-[2rem] p-2 z-50 w-48 flex flex-col gap-1";

export const LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS =
  "flex items-center gap-3 px-4 py-3 hover:bg-gray-50 rounded-2xl text-sm font-bold text-gray-700 transition text-left";

export const LIST_TOOLBAR_REGISTER_MENU_CLASS =
  "absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-2xl border border-gray-100 z-50 overflow-hidden";

export const LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS =
  "w-full text-left px-5 py-4 text-sm font-bold text-gray-700 hover:bg-gray-50 flex items-center gap-3";

export function getListToolbarSearchInputClass(theme) {
  return `w-full pl-11 pr-4 h-11 border border-gray-200 rounded-[2rem] text-sm focus:outline-none focus:${theme.border} transition bg-white shadow-sm font-bold`;
}

export function getListToolbarSortToggleClass(sortOrder, themeTextClass) {
  return `w-11 h-11 flex items-center justify-center bg-white rounded-full border border-gray-200 shadow-sm transition-all hover:bg-gray-50 active:scale-95 ${
    sortOrder === "desc" ? themeTextClass : "text-gray-400"
  }`;
}

export function getListToolbarSelectAllButtonClass(selectedCount) {
  return `h-11 rounded-full border border-transparent flex items-center justify-center gap-1 ${
    selectedCount > 0 ? "w-auto px-3 bg-[#354F38]/10 text-[#354F38] border-[#354F38]/20" : "w-11 text-gray-400 hover:text-gray-600"
  }`;
}

export function getListToolbarSelectAllIconClass(selectedCount) {
  return selectedCount > 0 ? "fill-[#354F38] text-white" : "";
}

export function getListToolbarViewModeButtonClass(isActive, theme) {
  return `w-11 h-11 rounded-full transition-all border border-transparent flex items-center justify-center ${
    isActive ? `${theme.lightBg} ${theme.text} ${theme.border}/20` : "text-gray-400 hover:text-gray-600"
  }`;
}

export function getListToolbarBulkDeleteButtonClass(selectedCount) {
  return `px-4 h-11 rounded-[2rem] text-sm font-bold shadow-sm transition flex items-center gap-2 flex-shrink-0 ${
    selectedCount > 0
      ? "bg-white text-red-500 border border-red-200 hover:bg-red-50"
      : "bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed"
  }`;
}

export function getListToolbarPrimaryActionButtonClass(themeBgClass) {
  return `${themeBgClass} text-white px-5 h-11 rounded-[2rem] text-sm font-bold hover:opacity-90 transition flex items-center gap-2 flex-shrink-0`;
}
